export default __webpack_public_path__ + "static/media/010-fast food.583c5188.svg";